import { Component, OnInit, Input } from '@angular/core';

import { ModalController, ToastController } from '@ionic/angular'
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';
import { GlobalService } from 'src/app/api/global.service';
import { DetailsPage } from '../details/details.page';
import { ProjectsService } from 'src/app/api/projects.service';




@Component({
  selector: 'app-select',
  templateUrl: './select.page.html',
  styleUrls: ['./select.page.scss'],
})
export class SelectPage implements OnInit {
  @Input() max_allowed_selections: number = 9999999999;
  @Input() client_guid: string = '';
  @Input() company_guid: string = '';
  url_mod = "";

  projects: any = null;
  loaded_projects = false;


  current_start_date: Date;
  current_end_date: Date;
  skeleton: any[];
  dateValue: Date[];
  selectedProjects = [];

  get isAtMaxSelections(): boolean {
    return this.selectedProjects.length >= this.max_allowed_selections;
  }



  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService,private projectsService: ProjectsService) { }

  ngOnInit() {
    if (this.client_guid) this.url_mod += `&client=${this.client_guid}`;
    else if (this.company_guid) this.url_mod += `&company=${this.company_guid}`;

  }

  async SelectProjects() {
    this.modalController.dismiss(this.selectedProjects);
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async UpdateSelection($event) {
    if ($event.length > this.max_allowed_selections) {
      this.selectedProjects = $event.slice(0, this.max_allowed_selections);
    } else {
      this.selectedProjects = $event;
    }
  }


}
